import React from "react";
import IShipmentUI from "../../../../models/IShipmentUI";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwButton from "../../../shared/OwButton/OwButton";
import UserService from "../../../../services/UserService";

type Props = {
    shipment: IShipmentUI;
    commitDeleteFn: (row: IShipmentUI) => void;
    cancelFn: () => void;
};

export const ConfirmDeleteShipmentModal = (props: Props) => {
    return (
        <div className={"ConfirmDeleteShipmentModal p-2"}>
            <div className={"d-flex justify-content-end"}>
                <OwButton centerIconClass={"fas fa-times"} className={"btn-danger"} />
            </div>

            <div className="text-center mb-2 mt-2">
                <OwTitle title={"confirm_delete_shipment"} tag={"h4"} leftIconName={"fas fa-box"} />
                <div className={"mt-3"}>
                    <OwLabel title={"carrier"} postText={":"} className={"me-2"} />
                    {props.shipment.Shipping_Carrier?.name}
                </div>
                <div>
                    <OwLabel title={"tracking"} postText={":"} className={"me-2"} />
                    {props.shipment.tracking}
                </div>
                <div>
                    <OwLabel title={"ship_date"} postText={":"} className={"me-2"} />
                    {UserService.parseLastUpdated(props.shipment.shipment_date)}
                </div>
                <div className="mt-5">
                    <OwButton
                        title={"ok"}
                        className={"btn-primary me-2"}
                        fn={() => {
                            props.commitDeleteFn(props.shipment);
                        }}
                    />
                    <OwButton
                        title={"cancel"}
                        className={"btn-danger"}
                        fn={() => {
                            props.cancelFn();
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
